<template>
  <div class="paid-details">
    <div class="details-content">
      <div class="details-row">
        <div class="paid-label">订单编号：</div>
        <div class="paid-va">{{form.orderNo}}</div>
      </div>
      <div class="details-row">
        <div class="paid-label">创建时间：</div>
        <div class="paid-va">{{form.createTime}}</div>
      </div>
      <div class="details-row">
        <div class="paid-label">金额（元）：</div>
        <!-- <div class="paid-va">{{form.amount}}</div> -->
        <div class="paid-va">{{form.pay.toFixed(2)}}</div>
      </div>
      <div class="details-row">
        <div class="paid-label">付款人：</div>
        <div class="paid-va">{{form.name}}</div>
      </div>
      <div class="details-row">
        <div class="paid-label">付款时间：</div>
        <div class="paid-va">{{form.updateTime}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import URL from "@/api/api";
export default {
  data(){
    return{
      form:{}
    }
  },
  mounted(){
    this.getData()
  },
  methods:{
    getData(){
      this.$fetchGet(URL.sassPaidDetails.url,{orderid:this.$route.query.id}).then((res) => {
        this.form=res.data.data
      })
    }
  }
}
</script>

<style lang="less" scoped>
.paid-details {
  width: 375px;
  height: 100vh;
  background: #fffbf8;
  .details-content {
    width: 355px;
    height: 201px;
    margin: 10px auto;
    background: url("./img/details-bg.png") no-repeat 100%;
    background-size: 100% 100%;
    overflow: hidden;
    .details-row {
      width: 315.5px;
      display: flex;
      margin: 21.5px auto auto;
      justify-content: space-between;
      font-family: Source Han Sans CN;
      font-weight: Regular;
      font-size: 12px;
      .paid-label {
        color: #333333;
      }
      .paid-va {
        color: #999999;
      }
    }
  }
}
</style>
